// Constructor
function OUAS() {

  this.touchEvent = ('ontouchstart' in window) || window.navigator.maxTouchPoints > 0 || (window.DocumentTouch && document instanceof DocumentTouch) ? "touchstart mousedown" : "click";
  this.wheelEvent = 'onwheel' in document ? 'wheel' : document.onmousewheel !== undefined ? 'mousewheel' : 'DOMMouseScroll';

  // // Audio wrapper
  this.audio = new Audio();

  this.started = false;
  this.scrolling = false;

  this.audio = false;

  this.preloader = new Preloader(this, $("#preloader"), $.proxy(this.preloaderBeforeFadeIn, this), $.proxy(this.preloaderAfterFadeIn, this));

  this.scrollMagicController = new ScrollMagic.Controller();
  this.scrollScene = false;
  this.scrollSpeedFactor = 2; // higher number = slower/longer animation

  // Create common ThreeJS renderer
  this.renderer = new THREE.WebGLRenderer({antialias: true, alpha: false});
  this.renderer.setSize(window.innerWidth, window.innerHeight);
  this.renderer.domElement.id = "ouas-main-canvas";
  $("#canvas-wrapper").append(this.renderer.domElement);

  // Create elements
  this.scenario = new Scenario(this, $("#game-1"), this.renderer);
  this.panoramicShimon = new Panoramic(this, this.renderer, "data/pano1.json?v=3");
  this.panoramicShimon.lat = 8;
  this.panoramicSinkholes = new Panoramic(this, this.renderer, "data/pano2.json?v=3");
  this.panoramicRonit = new Panoramic(this, this.renderer, "data/pano3.json?v=3");

  // this.videoplayer = new YoutubeVideoPlayer(this, $("#video-player"));
  this.videoplayer = new VimeoVideoPlayer(this, $("#video-player"));

  this.buttonActionTimeout = false;

  this.disableScroll();

  // Disable image ghost image on drag
  $('img').on('dragstart', function (event) {
    event.preventDefault();
  });

  this.init();
}

OUAS.prototype.init = function () {

  this.audio = new AudioPlayer();

  this.initButtons();
  this.defineAnimations();

  if ($("body").hasClass("page-main")) {
    this.scenario.introPlayedOnce = true;
  }

  this.gotoScenario();

  // Use the following code to start panoramic
  // this.gotoPano("shimon");
  // this.gotoPano("sinkholes");
  // this.gotoPano("ronit");

  $(window).on("resize", $.proxy(this.resize, this));

};

OUAS.prototype.resize = function () {
  this.renderer.setSize(window.innerWidth, window.innerHeight);
}

OUAS.prototype.disableScroll = function () {
  console.log("scroll disabled");
  window.ontouchmove = preventDefault; // mobile
  document.onkeydown = preventDefaultForScrollKeys;

  window.addEventListener(this.wheelEvent, preventDefault, {
    capture: true,
    passive: false
  });
}

OUAS.prototype.enableScroll = function () {
  console.log("scroll enabled");

  window.ontouchmove = null;
  document.onkeydown = null;

  window.removeEventListener(this.wheelEvent, preventDefault, {
    capture: true,
    passive: false
  });
}

OUAS.prototype.initButtons = function () {

  // Init big buttons dynamic action
  $("body").on(this.touchEvent, ".help, .trigger, .button, .buttons, .click-sound, .box-close, .language-buttons", $.proxy(function (e) {
    e.preventDefault();

    var el = $(e.currentTarget);
    if (typeof el.data("action") != "undefined") {
      var action = el.data("action")
      if (typeof this[action] == "function") {
        // Action is a function
        var functionArg = (typeof el.data("action-arg") != "undefined" ? el.data("action-arg") : "");
        console.log("Calling function : " + action + "(" + (functionArg ? functionArg : "") + ")");

        if (this.buttonActionTimeout !== false) {
          clearRequestTimeout(this.buttonActionTimeout);
          this.buttonActionTimeout = false;
        }

        this.buttonActionTimeout = requestTimeout($.proxy(function () {
          if (functionArg) {
            this[action](functionArg);
          } else {
            this[action]();
          }
        }, this), 250)
      } else {
        console.log("Action not found");
      }
    }

    // Play audio click
    // if (typeof this.settings.kiosk.click_sound !== "undefined" && this.settings.kiosk.click_sound != "") {
    //   this.audio.play(this.settings.kiosk.click_sound);
    // } else {
    //   this.audio.play("audio/default_click.wav");
    // }

  }, this));

};


OUAS.prototype.homeClick = function () {
  // On home click, go to Scenario if we are in panorama
  if ((this.panoramicShimon.started || this.panoramicSinkholes.started || this.panoramicRonit.started) && !this.scenario.started) {
    this.scenario.introPlayedOnce = true;
    this.gotoScenario();
  }
};

OUAS.prototype.playVideo = function (id) {
  var callback = false;
  if (id == "361332411" || id == "362504646") {
    callback = this.openFacebook;
  }
  this.videoplayer.loadVideo(id, callback);
};

OUAS.prototype.openFacebook = function () {
  var url = "https://www.facebook.com/onceuponasea";
  // window.open(url, '_blank');
  window.location.href = url;
};

OUAS.prototype.showMenu = function () {
  TweenMax.to("#menu", 0.3, {
    autoAlpha: 1,
  })
};

OUAS.prototype.hideMenu = function () {
  TweenMax.to("#menu", 0.3, {
    autoAlpha: 0,
  })
};

OUAS.prototype.defineAnimations = function (callback) {

};

OUAS.prototype.preloaderBeforeFadeIn = function () {
  console.log("OUAS: before preloader fadein");
  this.disableScroll();

  this.scenario.stop();
  this.panoramicShimon.stop();
  this.panoramicSinkholes.stop();
  this.panoramicRonit.stop();
}

OUAS.prototype.preloaderAfterFadeIn = function () {
  console.log("OUAS: after preloader fadein");
  this.scenario.afterPreloaderFadeIn();
  this.panoramicShimon.afterPreloaderFadeIn();
  this.panoramicSinkholes.afterPreloaderFadeIn();
  this.panoramicRonit.afterPreloaderFadeIn();
}

OUAS.prototype.gotoPano = function (panoId) {
  if (panoId == "shimon") {
    this.preloader.init(this.panoramicShimon);
  } else if (panoId == "sinkholes") {
    this.preloader.init(this.panoramicSinkholes);
  } else if (panoId == "ronit") {
    this.preloader.init(this.panoramicRonit);
  }
}

OUAS.prototype.gotoScenario = function () {
  this.preloader.init(this.scenario);
}

OUAS.prototype.reset = function () {

};

// Expose OUAS
window.OUAS = OUAS;

